(function($) {
  $('.content-nav-slider').slick({
    // autoplay: true,
    // pauseOnHover: true,
    infinite: false,
    variableWidth: true,
    swipeToSlide: true,
    // slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    // responsive: [
    //   {
    //     breakpoint: 1200,
    //     settings: {
    //       variableWidth: false,
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 992,
    //     settings: {
    //       variableWidth: false,
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     }
    //   },
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       variableWidth: false,
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     }
    //     // settings: "unslick"
    //   },
    // ]
  });
})($);